import {Pipe, PipeTransform} from "@angular/core";
import {ActivityExecutorParticipant} from "./activity-executor.participant";

@Pipe({ name: 'activityExecutor' })
export class ActivityExecutorPipe implements PipeTransform {
  constructor() { }

  transform(activityExecutors: ActivityExecutorParticipant[], defaultVal = ''): string {
    let r = '';
    activityExecutors.forEach(u => {
      r += u.activityDefName + '，';
    });
    if (r) {
      r = r.substring(0, r.length - 1);
    }
    return r ? r : defaultVal;
  }
}
